export enum E_HomeBanner {
    Inputs = 'Inputs',
    Outputs = 'Outputs',
    Slots = 'Slots',
    Notices = 'Notices',
    Status = 'Status',
}
